import { styled } from 'styled-components';

export const Wrapper = styled.div`
    margin-bottom: 8px;

    .date {
        display: flex;
        justify-content: space-between;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 130%;
        margin-bottom: 8px;
        color: #818c99;
        gap: 10px;

        :last-child {
            margin-bottom: 0;
        }

        &.date_return {
            font-style: normal;
            font-weight: 500;
            color: #1f2547;
        }
    }
`;
